import { grpc, someGrpc } from "@somewear/grpc";
import { actionSetEpicHandlerBuilder } from "@somewear/model";
import { combineEpics } from "redux-observable";

import { workspaceMeshKeyRotationsActions } from "./workspaceMeshKeyRotations.actions";

const getWorkspaceMeshKeyRotationHistoryEpic = actionSetEpicHandlerBuilder(
	workspaceMeshKeyRotationsActions.getMeshTrafficKeyHistory,
	(payload) =>
		grpc.prepareRequestWithPayload(someGrpc.getMeshTrafficKeyHistoryRequest, payload.data),
);

const triggerWorkspaceMeshKeyRotationEpic = actionSetEpicHandlerBuilder(
	workspaceMeshKeyRotationsActions.triggerMeshKeyRotation,
	(payload) =>
		grpc.prepareRequestWithPayload(someGrpc.triggerMeshKeyRotationRequest, payload.data),
	() => {
		return {
			onFulfilled: "Successfully triggered mesh key rotation",
			onPending: "",
			onRejected: "Failed to trigger mesh key rotation",
		};
	},
);

const scheduleWorkspaceMeshKeyRotationEpic = actionSetEpicHandlerBuilder(
	workspaceMeshKeyRotationsActions.scheduleMeshTrafficKeyRotation,
	(payload) =>
		grpc.prepareRequestWithPayload(
			someGrpc.updateScheduledTrafficKeyRotationRequest,
			payload.data,
		),
);

const skipScheduledWorkspaceMeshKeyRotationEpic = actionSetEpicHandlerBuilder(
	workspaceMeshKeyRotationsActions.skipScheduledMeshTrafficKeyRotation,
	(payload) =>
		grpc.prepareRequestWithPayload(
			someGrpc.skipScheduledTrafficKeyRotationRequest,
			payload.data,
		),
);

export const workspaceMeshKeyRotationsEpics = combineEpics<any, any, any>(
	getWorkspaceMeshKeyRotationHistoryEpic,
	triggerWorkspaceMeshKeyRotationEpic,
	scheduleWorkspaceMeshKeyRotationEpic,
	skipScheduledWorkspaceMeshKeyRotationEpic,
);
